import React from 'react';

import { MissionControlStaffingTableJobsBase } from './_mission-control-staffing-table-jobs-base';

export function MissionControlStaffingTableRequestAtRisk() {
  return <MissionControlStaffingTableJobsBase tableKind="request_at_risk" />;
}
